import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'WaitingDots',
  props: {
    label: null
  },
  setup(__props: any) {

const props = __props as { label?: string };



return { __sfc: true,props }
}

})